import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Grid } from '@mui/material';
import { GridContext } from 'contexts/GridContext';
import { DropsContext } from 'contexts/DropsContext';
import { EntidadesContext } from 'contexts/EntidadesContext';
import { useModal, useDialog } from 'components/Modals';
import DeleteModal from 'components/Modals/DeleteModal';
import Loader from 'components/Loader';
import AddModal from './Components/AddModal';
import Sidebar from './Tabs/Sidebar';
import Tabs from './Tabs';

const Pessoal = () => {
  const [tab, setTab] = useState(null);
  const [pessoal, setPessoal] = useState(null);
  const [funcionario, setFuncionario] = useState(null);
  const { funcionario_id } = useParams();
  const { drops } = useContext(DropsContext);
  const { closeDialog } = useDialog();
  const { openModal, closeModal } = useModal();
  const { getLoading, getPessoal } = useContext(EntidadesContext);
  const { postGrid, postLoading, deleteGrid, deleteLoading } =
    useContext(GridContext);
  const loading = getLoading || postLoading || deleteLoading;

  const onSubmit = ({ rotina, ...data }) =>
    postGrid({ data: { data, rotina }, cb: loadData });

  const onAdd = () =>
    openModal(
      <AddModal onSubmit={onSubmit} funcionario_id={Number(funcionario_id)} />,
      90
    );

  const onDelete = (params) =>
    openModal(
      <DeleteModal onSubmit={() => deleteGrid({ params, cb: loadData })} />
    );

  const props = {
    tab,
    drops,
    onAdd,
    setTab,
    loading,
    pessoal,
    onSubmit,
    onDelete,
    setPessoal,
    funcionario,
  };

  const loadData = () => {
    const cb = (res) => {
      setFuncionario(res);
      closeDialog();
      closeModal();
    };
    getPessoal({ params: { funcionario_id }, cb });
  };

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    if (!funcionario?.Pessoais?.length) {
      setPessoal(null);
      return;
    }

    const atualizado = pessoal
      ? funcionario?.Pessoais?.find((p) => p?.id === pessoal?.id)
      : null;

    if (atualizado) {
      setPessoal(atualizado);
    } else {
      setPessoal(funcionario?.Pessoais?.[0]);
    }
  }, [funcionario]);

  useEffect(() => {
    if (funcionario && !tab) {
      setTab(0);
    }
  }, [funcionario, tab]);

  if (getLoading) return <Loader />;

  return (
    <Grid container spacing={2} height="90vh">
      <Grid item xs={12} md={3} sx={{ height: '100%', overflowY: 'auto' }}>
        <Sidebar {...props} />
      </Grid>
      <Grid item xs={12} md={9} sx={{ height: '100%', overflowY: 'auto' }}>
        <Tabs {...props} />
      </Grid>
      <Grid item xs={12} />
    </Grid>
  );
};

export default Pessoal;
